export enum AssetType {
    OsnovnoSredstvo = 2,
    SitniInventar = 1
}